import { useAuth } from "@/hooks/use-auth-compat";
import { StudentLayout } from "@/components/student/layout/StudentLayout";
import OfferingSearchPage from "./OfferingSearchPage";
import type { OfferingType } from "@/services/offeringSearchService";

/**
 * Auth-conditional layout for the per-type search pages (ADR-088 AC18):
 * logged-in users see the page inside the student shell (left nav present);
 * anonymous visitors get the standalone page (public header/footer only).
 */
export default function OfferingSearchRoute({ offeringType }: { offeringType: OfferingType }) {
  const { isAuthenticated } = useAuth();
  if (isAuthenticated) {
    return (
      <StudentLayout>
        <OfferingSearchPage offeringType={offeringType} embedded />
      </StudentLayout>
    );
  }
  return <OfferingSearchPage offeringType={offeringType} />;
}
